<template>
	<c-dialog ref="dialog" width="800" mode="slide" mask-close>
		<div class="m-ship-body">
			<!-- 结果视图：批量发货存在失败单时逐单展示原因 -->
			<template v-if="resultMode">
				<div class="m-result-summary">
					<span class="m-count-success">发货成功 {{successCount}}单</span>
					<span v-if="failCount" class="m-count-fail">，失败 {{failCount}}单</span>
				</div>
				<c-table :data="failList" :paging="false" empty-text="没有发货失败的订单">
					<c-table-column label="销售订单号" name="order_no" width="200"></c-table-column>
					<c-table-column label="商品信息" min-width="300">
						<template #default="{data}">
							<m-product-info :name="data.product_name" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
						</template>
					</c-table-column>
					<c-table-column label="失败原因" min-width="240">
						<template #default="{data}"><span class="m-reason">{{data.reason}}</span></template>
					</c-table-column>
				</c-table>
			</template>

			<!-- 发货表单视图 -->
			<template v-else>
				<!-- 订单信息 -->
				<div class="m-ship-order">
					<p>已选择 {{orderIds.length}} 个待发货订单，确认发货后订单直接完成</p>
					<p v-if="multiCustomer" class="m-multi-tip">本批包含多个客户的订单，已限制邮寄发货，仅支持当面交接</p>
				</div>

				<!-- 发货方式（整批共用：当面交接/邮寄发货） -->
				<c-form vertical unit-width="100%" style="padding: 0;">
					<c-form-item label="发货方式" required :tip="shipType == 1 ? '线下当面交接，无需物流信息，确认后订单直接完成' : '邮寄发货的收货与物流信息将应用到本批全部订单'">
						<c-radio-group v-model="shipType" :options="shipTypeOptions"></c-radio-group>
					</c-form-item>

					<!-- 收货信息（仅邮寄发货展示，必填） -->
					<template v-if="shipType == 2">
						<c-form-item label="收货人" required>
							<c-input v-model="receiverName" placeholder="请输入收货人姓名" maxlength="50"></c-input>
						</c-form-item>
						<c-form-item label="联系电话" required>
							<c-input v-model="receiverPhone" placeholder="请输入联系电话" maxlength="20"></c-input>
						</c-form-item>
						<c-form-item label="收货地址" required>
							<c-input v-model="receiverAddress" placeholder="请输入收货地址" maxlength="200"></c-input>
						</c-form-item>
					</template>

					<!-- 邮寄发货信息 -->
					<template v-if="shipType == 2">
						<c-form-item label="快递公司" required>
							<c-select v-model="expressCompanyCode" async @search="searchLogisticsCompany" :value-data="selectedExpressCompanyData" placeholder="请选择快递公司" @change="changeExpressCompany"></c-select>
						</c-form-item>
						<c-form-item label="快递单号" required>
							<c-input v-model="expressNo" placeholder="请输入快递单号" maxlength="50"></c-input>
						</c-form-item>
					</template>
				</c-form>
			</template>
		</div>

		<template #button>
			<c-button v-if="!resultMode" size="dialog" color="main" :loading="submitting" @click="submitHandle">确认发货</c-button>
			<c-button size="dialog" @click="$refs.dialog.close()">{{resultMode ? '知道了' : '取消'}}</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'offlineBatchShipDialog',

		data() {
			return {
				submitting: false,
				/**结果视图开关：提交后存在失败单时切换展示逐单失败原因*/
				resultMode: false,
				successCount: 0,
				failCount: 0,
				failList: [],
				orderIds: [],
				receiverName: '',
				receiverPhone: '',
				receiverAddress: '',
				shipType: 1,
				/*同批是否跨多客户：true 时发货方式仅保留当面交接*/
				multiCustomer: false,
				/*已选快递公司完整项[{name, value}]，用于async下拉的值回显*/
				selectedExpressCompanyData: [],
				expressCompanyCode: '',
				expressCompanyName: '',
				expressNo: ''
			}
		},

		computed: {
			/*********发货方式选项：跨多客户批次去掉邮寄发货，仅保留当面交接**********/
			shipTypeOptions() {
				var options = [{
					name: '当面交接',
					value: 1
				}];
				if (!this.multiCustomer) {
					options.push({
						name: '邮寄发货',
						value: 2
					});
				}
				return options;
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				this.orderIds = data.orderIds || [];
				this.multiCustomer = !!data.multiCustomer;
				this.receiverName = '';
				this.receiverPhone = '';
				this.receiverAddress = '';
				this.shipType = 1;
				this.expressCompanyCode = '';
				this.expressCompanyName = '';
				/*手动录单快递公司无历史回显值，重置异步下拉选中项*/
				this.selectedExpressCompanyData = [];
				this.expressNo = '';
				this.resultMode = false;
				this.successCount = 0;
				this.failCount = 0;
				this.failList = [];
				this.submitting = false;
				this.$refs.dialog.open({title: '批量发货'});
			},

			/*********异步搜索快递公司（LOGISTICS_TYPE字典，keyword映射后端name模糊查询）**********/
			searchLogisticsCompany(keyword, resolve) {
				this.request({
					url: '/dic/info/options',
					data: {
						dic_type_code: 'LOGISTICS_TYPE',
						name: keyword
					},
					success: data => {
						resolve(data || []);
					}
				});
			},

			/*********切换快递公司时同步名称（async下拉change回传完整选中项，清除时为空对象）**********/
			changeExpressCompany(data) {
				var valid = data && data.value !== undefined;
				this.selectedExpressCompanyData = valid ? [data] : [];
				this.expressCompanyName = valid ? (data.name || '') : '';
			},

			/*********确认批量发货**********/
			submitHandle() {
				if (this.shipType == 2) {
					if (!this.receiverName.trim()) {
						this.$message({message: '请填写收货人', type: 'warn'});
						return;
					}
					if (!this.receiverPhone.trim()) {
						this.$message({message: '请填写联系电话', type: 'warn'});
						return;
					}
					if (!this.receiverAddress.trim()) {
						this.$message({message: '请填写收货地址', type: 'warn'});
						return;
					}
					if (!this.expressCompanyCode) {
						this.$message({message: '请选择快递公司', type: 'warn'});
						return;
					}
					if (!this.expressNo.trim()) {
						this.$message({message: '请输入快递单号', type: 'warn'});
						return;
					}
				}

				var data = {
					order_ids: this.orderIds,
					ship_type: this.shipType
				};
				if (this.shipType == 2) {
					data.receiver_name = this.receiverName.trim();
					data.receiver_phone = this.receiverPhone.trim();
					data.receiver_address = this.receiverAddress.trim();
					data.express_company = this.expressCompanyName;
					data.express_no = this.expressNo.trim();
				}

				this.submitting = true;
				this.request({
					url: '/offline/sale/order/ship_batch',
					data: data,
					loading: true,
					success: (result, msg) => {
						this.submitting = false;
						//先刷新列表：失败单状态未变、成功单已完成的口径都要同步到列表
						this.$emit('resolve');
						if (result && result.fail_count) {
							//存在失败单：切换结果视图逐单展示原因
							this.successCount = result.success_count || 0;
							this.failCount = result.fail_count || 0;
							this.failList = result.fail_list || [];
							this.resultMode = true;
						} else {
							this.$message({message: msg || '批量发货成功', type: 'success'});
							this.$refs.dialog.close();
						}
					},
					error: () => {
						this.submitting = false;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-ship-body {
		padding: 16px 24px;
		min-height: 200px;
	}

	.m-ship-order {
		padding: 10px 16px;
		background: #f9f9f9;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		line-height: 24px;
		font-size: 13px;
		color: #333;
		margin-bottom: 12px;
	}

	.m-multi-tip {
		color: #ff9900;
	}

	.m-result-summary {
		padding: 12px 15px;
		margin-bottom: 12px;
		background: #f5f7fa;
		border-radius: 4px;
		font-size: 14px;

		.m-count-success {
			color: #19be6b;
		}

		.m-count-fail {
			color: #ed3f14;
		}
	}

	.m-reason {
		color: #ed3f14;
	}
</style>
